/* eslint-disable */
import GraphQL from '../../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ContentRelationsPanelQueryVariables = GraphQL.Exact<{
  legacyUrlId: GraphQL.Scalars['Int']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type ContentRelationsPanelQuery = { readonly __typename?: 'Query', readonly lookupPageByLegacyId: { readonly __typename?: 'Page', readonly id: CK.UrlId, readonly numberOfIncomingCanonicalLinks: number | null, readonly numberOfIncomingInternalLinks: number | null, readonly numberOfIncomingRedirects: number | null, readonly pageTypeData: { readonly __typename?: 'PageTypeData', readonly numberOfOutgoingExternalLinks: number, readonly numberOfOutgoingInternalLinks: number } | null } | null };


export const ContentRelationsPanelDocument = gql`
    query ContentRelationsPanel($legacyUrlId: Int!, $websiteId: WebsiteId!) {
  lookupPageByLegacyId(legacyUrlId: $legacyUrlId, websiteId: $websiteId) {
    id
    numberOfIncomingCanonicalLinks
    numberOfIncomingInternalLinks
    numberOfIncomingRedirects
    pageTypeData {
      numberOfOutgoingExternalLinks
      numberOfOutgoingInternalLinks
    }
  }
}
    `;

/**
 * __useContentRelationsPanelQuery__
 *
 * To run a query within a React component, call `useContentRelationsPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentRelationsPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentRelationsPanelQuery({
 *   variables: {
 *      legacyUrlId: // value for 'legacyUrlId'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useContentRelationsPanelQuery(baseOptions: Apollo.QueryHookOptions<ContentRelationsPanelQuery, ContentRelationsPanelQueryVariables> & ({ variables: ContentRelationsPanelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentRelationsPanelQuery, ContentRelationsPanelQueryVariables>(ContentRelationsPanelDocument, options);
      }
export function useContentRelationsPanelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentRelationsPanelQuery, ContentRelationsPanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentRelationsPanelQuery, ContentRelationsPanelQueryVariables>(ContentRelationsPanelDocument, options);
        }
export function useContentRelationsPanelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentRelationsPanelQuery, ContentRelationsPanelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentRelationsPanelQuery, ContentRelationsPanelQueryVariables>(ContentRelationsPanelDocument, options);
        }
export type ContentRelationsPanelQueryHookResult = ReturnType<typeof useContentRelationsPanelQuery>;
export type ContentRelationsPanelLazyQueryHookResult = ReturnType<typeof useContentRelationsPanelLazyQuery>;
export type ContentRelationsPanelSuspenseQueryHookResult = ReturnType<typeof useContentRelationsPanelSuspenseQuery>;
export type ContentRelationsPanelQueryResult = Apollo.QueryResult<ContentRelationsPanelQuery, ContentRelationsPanelQueryVariables>;